import { render, staticRenderFns } from "./MultiLanguagesDialog.vue?vue&type=template&id=e54f4bf0&scoped=true&lang=pug&"
import script from "./MultiLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLanguagesDialog.vue?vue&type=style&index=0&id=e54f4bf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54f4bf0",
  null
  
)

export default component.exports